import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActionSheetController } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';
import * as debug from 'debug';
import { EnvVariables } from '../../environments/environment';
import * as _ from 'lodash';

@Injectable()
export class SocialSharingProvider {
  log = debug('app:SocialSharingProvider');

  constructor(
    public http: HttpClient,
    public actionSheetCtrl: ActionSheetController,
    public socialSharing: SocialSharing,
    public env: EnvVariables
  ) {
    this.log('constructed');
  }

  postURL(post) {
    if (post.postType === 'ARTICLE') {
      const url =
        _.get(post, 'articleInformation.linkUrl') + '?utm_source=CDLLifeApp';
      this.log('postURL', url);
      return url;
    }
    this.log('url to post with', this.env.shareURL + '/' + post._id);
    return `${this.env.shareURL}/${post._id}`;
  }

  shouldIncrementSharing(shareReponse) {
    // Android returns false even if the user
    // canceled the sharing event.  The current logic will
    // Return true if shareResponse completed is true
    // Return false if shareResponse completed is false and the app contains apple
    // otherwise return true
    const completed = _.get(shareReponse, 'completed'),
      app = _.get(shareReponse, 'app');
    if (completed) {
      return true;
    } else if (_.includes(app, 'apple')) {
      return false;
    } else {
      return true;
    }
  }

  shareApp(
    message: string = 'Download the all-in-one trucker app here: http://onelink.to/cdllifeapp',
    subject: string = 'Check out the CDLLife mobile app.'
  ) {
    window['event'].preventDefault();
    window['event'].stopPropagation();

    return new Promise((resolve, reject) => {
      this.socialSharing.shareWithOptions({ message, subject }).then(res => {
        resolve(res);
      });
    });
  }

  sharePost(post: any) {
    window['event'].preventDefault();
    window['event'].stopPropagation();

    return new Promise((resolve, reject) => {
      this.socialSharing
        .shareWithOptions({
          subject: `Check out this post on the CDLLife app`,
          message: this.postURL(post),
        })
        .then(res => {
          resolve(res);
        });
    });
  }

  shareQRCode(file?: any) {
    // window['event'].preventDefault();
    // window['event'].stopPropagation();

    return new Promise((resolve, reject) => {
      this.socialSharing
        .shareWithOptions({
          files: [file],
        })
        .then(res => {
          resolve(res);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/social-sharing/social-sharing.ts